import { Link } from 'react-router-dom';
import styles from './DevCard.module.css';

export default function DevCard({ post, style = {} }) {
  return (
    <Link
      to={`/dev/${post.slug}`}
      className={styles.card}
      style={{ animationDelay: style.animationDelay || '0s' }}
    >
      <div className={styles.top} style={{ background: post.color }}>
        <span className={styles.emoji}>{post.emoji}</span>
        <span className={`badge ${styles.catBadge}`} style={{ background: post.accentColor }}>
          {post.category}
        </span>
      </div>
      <div className={styles.body}>
        <div className="card-meta">
          <span className="card-category" style={{ color: post.accentColor }}>
            Dev Blog
          </span>
          <span className="card-time">{post.readTime}</span>
        </div>
        <h3 className="card-title">{post.title}</h3>
        <p className="card-desc">{post.description}</p>
        <div className="card-tags">
          {post.tags.map(t => <span key={t} className="tag">#{t}</span>)}
        </div>
        <div className="card-footer">
          <span className="card-date">{post.date}</span>
          <span className={styles.readMore} style={{ color: post.accentColor }}>
            Read Post →
          </span>
        </div>
      </div>
    </Link>
  );
}
